import { useState } from "react";
import { PlugZap } from "lucide-react";
import { toast } from "sonner";
import { errorMessage } from "../../../../api/client";
import { twilioApi, type TwilioView } from "../../../../api/twilio";
import { Button } from "../../../../components/ui";
import { Card, CheckIcon, when } from "./parts";

export function TestConnectionCard({ v, onChange }: { v: TwilioView; onChange: (n: TwilioView) => void }) {
  const [busy, setBusy] = useState(false);
  const t = v.last_test;
  const run = async () => {
    setBusy(true);
    try {
      const n = await twilioApi.test();
      onChange(n);
      if (n.last_test?.ok) toast.success("Test connection passed");
      else toast.error("Test connection found problems");
    } catch (e) { toast.error(errorMessage(e)); } finally { setBusy(false); }
  };
  return (
    <Card title="Test connection" icon={<PlugZap className="h-5 w-5 text-signal" />} testId="twilio-test-card"
      aside={<Button onClick={run} loading={busy} disabled={!v.fields.account_sid.set || !v.fields.auth_token.set} data-testid="twilio-test-connection">Test connection</Button>}>
      <p className="text-sm text-zinc-400">Reads your Twilio account (changes nothing), except it creates the “GamedayTime” Verify Service if it doesn't exist yet.</p>
      {t ? (
        <div className="mt-4" data-testid="twilio-test-result">
          <p className={`text-sm font-semibold ${t.ok ? "text-emerald-300" : "text-red-300"}`} data-testid="twilio-test-overall">
            {t.ok ? "Passed" : "Not passed"} · {when(t.at)}{!v.last_test_current && " · credentials changed since, test again"}
          </p>
          <ul className="mt-3 space-y-2">
            {t.checks.map((c) => (
              <li key={c.key} className="flex gap-2.5 text-sm" data-testid={`twilio-check-${c.key}`} data-ok={c.ok}>
                <CheckIcon ok={c.ok} required={c.required} />
                <span className="min-w-0"><span className="font-medium text-white">{c.label}</span>{!c.required && <span className="text-zinc-500"> (recommended)</span>}<span className="block break-words text-zinc-400 [overflow-wrap:anywhere]">{c.detail}</span></span>
              </li>
            ))}
          </ul>
        </div>
      ) : <p className="mt-4 text-sm text-zinc-500" data-testid="twilio-test-none">Not tested yet.</p>}
    </Card>
  );
}
